import { __assign } from "tslib";
// DS: i3.2
import React from 'react';
import IconWrap from '../../IconWrap';
var Add = function (props) {
    return (React.createElement(IconWrap, __assign({}, props),
        React.createElement("svg", { fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24" },
            React.createElement("path", { clipRule: "evenodd", d: "M18 11.9a1 1 0 0 1-1 1h-4V17a1 1 0 0 1-.875.992L12 18a1 1 0 0 1-.993-.883L11 17v-4.1H7a1 1 0 1 1 0-2l4-.002V7a1 1 0 0 1 .875-.992L12 6a1 1 0 0 1 .993.883L13 7v3.898l4 .002a1 1 0 0 1 1 1Z" }))));
};
Add.displayName = 'Add';
export default Add;
//# sourceMappingURL=Add.js.map